import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { iteroCheckoutService } from 'services';
import { IteroSaleType } from 'types';

export const useCalculateIteroTax = (
  proposalId: string,
  billingAddressId: string,
  shippingAddressId: string,
  orderStep: string,
  saleType: IteroSaleType
) => {
  const isEnabled =
    Boolean(proposalId && billingAddressId && shippingAddressId) &&
    orderStep === 'scannerPayment' &&
    saleType !== 'Rental';

  return useQuery(
    `${ServerStateKeysEnum.iteroTax}-${proposalId}`,
    () => {
      return iteroCheckoutService.calculateIteroTax(
        proposalId,
        billingAddressId,
        shippingAddressId
      );
    },
    {
      enabled: isEnabled,
    }
  );
};
